<template>
    <div class="specialist">
        <div class="banner-head">
            <div class="introduction">
                <div style="height: 254px;"></div>
                <div class="one-to-one">专家一对一规划</div>
                <div style="height: 24px;"></div>
                <div class="customization">私属定制化全周期解决方案，名企导师全程陪跑</div>
            </div>
        </div>
        <div class="content-box">
            <div class="content-box-child">
                <img src="../../assets/specialist/bg.png" class="bg" />
                <div class="content">
                    <div style="height: 1650px; display: flex; flex-direction: column; justify-content: space-between;" >
                           <!--职业定位为发展-->
                    <div class="career-positioning" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="0">
                        <div class="career-positioning-box">
                            <div class="text">
                                <div class="career-positioning-txt">职业定位与发展规划</div>
                                <div style="height: 10px;"></div>
                                <div class="career-positioning-introduction">
                                    深度剖析个人优势，定制短中长三期行动路径，通过一对一深度沟通，精准梳理核心竞争力，制定可落地的职业发展蓝图与执行方案。
                                </div>
                                <div style="height: 50px;"></div>
                                <div class="tags">
                                    <div class="tag">优势竞争力解码</div>
                                    <div class="tag">发展路线图</div>
                                    <div class="tag">发展路线图</div>
                                </div>
                            </div>
                            <div>
                                <img src="../../assets/specialist/career-positioning.png"
                                    style="width: 453px; height: 260px;" />
                            </div>
                        </div>
                    </div>
                    <!--简历优化和面试辅导-->
                    <div class="resume-interview" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-200">
                        <div class="resume">
                            <div class="resume-box">
                                <div style="height: 40px;"></div>
                                <img class="resume-icon" src="../../assets/specialist/resume.png" style="width: 98px; height: 98px;" />
                                <div style="height: 20px;"></div>
                                <div class="title">简历深度优化</div>
                                <div style="height: 10px;"></div>
                                <div class="txt">
                                    帮助你3天重塑职业名片，高亮优势直击企业需求，提炼核心竞争力，结合目标企业画像快速优化简历，确保个人价值与岗位高度契合。
                                </div>
                                <div style="height: 40px;"></div>
                                <div class="tags">
                                    <div class="tag">JD关键词狙击</div>
                                    <div class="tag">STAR经历重构</div>
                                    <div class="tag">匹配度提升</div>
                                </div>
                            </div>
                        </div>
                        <div class="resume">
                            <div class="resume-box">
                                <div style="height: 40px;"></div>
                                <img class="resume-icon" src="../../assets/specialist/interview-coaching.png" style="width: 98px; height: 98px;" />
                                <div style="height: 20px;"></div>
                                <div class="title">面试辅导</div>
                                <div style="height: 10px;"></div>
                                <div class="txt">
                                    定向攻克目标岗位，实战模拟打造面试通关力，基于岗位定制题库与策略，强化应答技巧与行业认知，通过模拟面试精准提升临场表现。
                                </div>
                                <div style="height: 40px;"></div>
                                <div class="tags">
                                    <div class="tag">定制化试题</div>
                                    <div class="tag">模拟实战</div>
                                    <div class="tag">微表情管理</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--offer选择和试用期护航--->
                    <div class="resume-interview" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-200">
                        <div class="resume">
                            <div class="resume-box">
                                <div style="height: 40px;"></div>
                                <img class="resume-icon" src="../../assets/specialist/offer.png" style="width: 98px; height: 98px;" />
                                <div style="height: 20px;"></div>
                                <div class="title">Offer选择</div>
                                <div style="height: 10px;"></div>
                                <div class="txt">
                                    多维评估科学决策，锁定最优职业跳板，深度解析Offer隐性价值与风险，利用Offer对比决策树模型（薪资/成长性/稳定性三维评分），助力选择效益最大化选项。
                                </div>
                                <div style="height: 40px;"></div>
                                <div class="tags">
                                    <div class="tag">职业价值计算</div>
                                    <div class="tag">企业背景调查</div>
                                    <div class="tag">风险预警评估</div>
                                </div>
                            </div>
                        </div>
                        <div class="resume">
                            <div class="resume-box">
                                <div style="height: 40px;"></div>
                                <img class="resume-icon" src="../../assets/specialist/escort.png" style="width: 98px; height: 98px;" />
                                <div style="height: 20px;"></div>
                                <div class="title">试用期护航</div>
                                <div style="height: 10px;"></div>
                                <div class="txt">
                                    风险预判+快速适应，稳渡职场关键考核期，识别试用期潜在挑战，提供适应性策略与资源支持，确保新人在试用期站稳脚跟、赢得信任。
                                </div>
                                <div style="height: 40px;"></div>
                                <div class="tags">
                                    <div class="tag">破冰策略</div>
                                    <div class="tag">个人价值展示</div>
                                    <div class="tag">风险判断</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--职场问题解决和求职陪跑--->
                    <div class="workplace-issues" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-200">
                        <div class="problem">
                            <div class="problem-box">
                                 <div style="height: 40px;"></div>
                                 <img src="../../assets/specialist/problem.png" style="width: 98px; height: 98px; text-align: left;"/>
                                 <div style="height: 20px;"></div>
                                 <div class="title">职场问题解决</div>
                                 <div style="height: 10px;"></div>
                                 <div class="txt">破解发展瓶颈，重构职业信心与战略布局，梳理困境根源，定制破局策略，同步优化求职路径与长期发展规划，重启职业动能。</div>
                                 <div style="height: 26.5px;"></div>
                                 <div class="tag">
                                     <div class="tag-item">根因分析</div>
                                     <div class="tag-item">破局策略</div>
                                     <div class="tag-item">优化路径</div>
                                 </div>
                            </div>
                        </div>
                        <div class="accompanying-run">
                            <div class="accompanying-run-box">
                                <div style="height: 40px;"></div>
                                 <img src="../../assets/specialist/accompanying-run.png" style="width: 98px; height: 98px; text-align: left;"/>
                                 <div style="height: 20px;"></div>
                                 <div class="title">求职陪跑套餐</div>
                                 <div style="height: 10px;"></div>
                                 <div class="txt">以 “全流程深度陪跑+企业资源护航” 双引擎驱动，通过精准规划发展路径、定制高竞争力简历、实战模拟与面试复盘、企业库定向推荐、多维度Offer评估及入职后风险护航，系统性攻克求职各环节痛点，并依托合作企业资源精准匹配岗位，助力稳渡试用期，实现从职业迷茫到高质量就业的无缝衔接与闭环保障。</div>
                                 <div style="height: 40px;"></div>
                                 <div class="tag">
                                     <div class="tag-item">全流程深度陪跑</div>
                                     <div class="tag-item">企业资源护航</div>
                                     <div class="tag-item">名师护航</div>
                                 </div>
                            </div>
                        </div>
                    </div>


                    </div>
                   
                </div>
            </div>
        </div>
        <contact-us/>
    </div>
</template>

<script>
import contactUs from '../../components/ContactUs/contactUs.vue'
export default {
    name: 'specialist',
    components:{
        contactUs
    },
  mounted() {
    window.scrollTo({
      top: 0,
    })
  }
}
</script>

<style lang="scss" scoped>
.banner-head {
    width: 100%;
    height: 700px;
    background-image: url("../../assets/specialist/banner-head.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;

    .introduction {
        width: 1280px;
        height: 156px;
        margin: 0 auto;

        .one-to-one {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 60px;
            color: #FF6E00;
            line-height: 66px;
            text-align: left;
            font-style: normal;
        }

        .customization {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 36px;
            color: #171A1D;
            line-height: 66px;
            text-align: left;
            font-style: normal;
        }
    }
}

.content-box {
    height: 1830px;
    background: rgba(246, 246, 246, 0.6);
    box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);

    .content-box-child {
        height: 1750px;
        width: 100%;
        position: relative;
        display: flex;

        .bg {
            width: 1217px;
            height: 1217px;
            position: absolute;
            right: 0;
            bottom: 0;
        }

        .content {
            height: 1730px;
            width: 1280px;
            display: flex;
            flex-direction: column;
            margin: 0 auto;
            justify-content: flex-end;

            .career-positioning {
                width: 1280px;
                height: 300px;
                background: #FFFFFF;
                box-shadow: 0px 6px 10px 0px rgba(192, 192, 192, 0.15);
                border-radius: 16px;

                .career-positioning-box {
                    width: 1104px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    margin: 0 auto;
                    justify-content: space-between;

                    .text {
                        .career-positioning-txt {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            font-size: 24px;
                            color: #171A1D;
                            line-height: 33px;
                            text-align: left;
                            font-style: normal;
                        }

                        .tags {
                            width: 416px;
                            height: 36px;
                            display: flex;
                            justify-content: space-between;

                            .tag {
                                width: 132px;
                                height: 36px;
                                border-radius: 6px;
                                border: 1px solid #FF6E00;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FF6E00;
                                line-height: 22px;
                                text-align: center;
                                font-style: normal;
                                line-height: 36px;
                            }
                        }



                        .career-positioning-introduction {
                            width: 540px;
                            height: 62px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 16px;
                            color: rgba(23, 26, 29, 0.6);
                            line-height: 31px;
                            text-align: justify;
                            font-style: normal;
                        }
                    }
                }
            }

            .resume-interview {
                width: 1280px;
                height: 420px;
                display: flex;
                justify-content: space-between;

                .resume,
                .interview {
                    width: 628px;
                    height: 420px;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.5) 100%);
                    box-shadow: 0px 6px 10px 0px rgba(192, 192, 192, 0.15);
                    border-radius: 16px;
                    backdrop-filter: blur(10px);

                    .resume-box {
                        width: 453px;
                        height: 100%;
                        margin: 0 auto;
                        display: flex;
                        flex-direction: column;
                        .resume-icon {
                            text-align: left;
                        }

                        .tags {
                            width: 410px;
                            height: 36px;
                            display: flex;
                            justify-content: space-between;

                            .tag {
                                width: 130px;
                                height: 36px;
                                border-radius: 6px;
                                border: 1px solid #FF6E00;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FF6E00;
                                line-height: 22px;
                                text-align: center;
                                font-style: normal;
                                line-height: 36px;
                            }
                        }

                        .title {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            font-size: 24px;
                            color: #171A1D;
                            line-height: 33px;
                            text-align: left;
                            font-style: normal;
                        }

                        .txt {
                            width: 453px;
                            height: 93px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 16px;
                            color: rgba(23, 26, 29, 0.6);
                            line-height: 31px;
                            text-align: justify;
                            font-style: normal;
                        }
                    }


                }
            }

            .workplace-issues{
                width: 1280px;
                height: 450px;
                display: flex;
                justify-content: space-between;
                .problem{
                    width: 521px;
                    height: 450px;
                    background: linear-gradient( 180deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.5) 100%);
                    box-shadow: 0px 6px 10px 0px rgba(192,192,192,0.15);
                    border-radius: 16px;
                    backdrop-filter: blur(10px);
                    .problem-box{
                        width: 345px;
                        margin: 0 auto;
                        text-align: left;

                        .tag{
                            height: 82px;
                            width: 270px;
                            display: flex;
                            flex-wrap: wrap;
                            align-content: space-between;
                            justify-content: space-between;
                            .tag-item{
                                width: 130px;
                                height: 36px;
                                border-radius: 6px;
                                border: 1px solid #FF6E00;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FF6E00;
                                line-height: 36px;
                                text-align: center;
                                font-style: normal;
                            }
                        }

                        .title{
                            width: 144px;
                            height: 33px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            font-size: 24px;
                            color: #171A1D;
                            line-height: 33px;
                            text-align: left;
                            font-style: normal;
                        }
                        .txt{
                            width: 345px;
                            height: 93px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 16px;
                            color: rgba(23,26,29,0.6);
                            line-height: 31px;
                            text-align: justify;
                            font-style: normal;
                        }
                    }
                }
                .accompanying-run{
                    width: 738px;
                    height: 450px;
                    background: linear-gradient( 180deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.5) 100%);
                    box-shadow: 0px 6px 10px 0px rgba(192,192,192,0.15);
                    border-radius: 16px;
                    backdrop-filter: blur(10px);
                    .accompanying-run-box{
                        width: 561px;
                        margin: 0 auto;
                        text-align: left;
                        .title{
                            width: 144px;
                            height: 33px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            font-size: 24px;
                            color: #171A1D;
                            line-height: 33px;
                            text-align: left;
                            font-style: normal;
                        }
                        .txt{
                            width: 561px;
                            height: 124px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 16px;
                            color: rgba(23,26,29,0.6);
                            line-height: 31px;
                            text-align: justify;
                            font-style: normal;
                        }
                        .tag{
                            width: 416px;
                            height: 36px;
                            display: flex;
                            justify-content: space-between;
                            .tag-item{
                                width: 132px;
                                height: 36px;
                                border-radius: 6px;
                                border: 1px solid #FF6E00;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FF6E00;
                                line-height: 36px;
                                text-align: center;
                                font-style: normal;
                            }
                        }
                    }
                }

            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/specialist/index.vue